import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import {AnimationItem, BMSegmentStartEvent} from "lottie-web";
import {dummyAnimation} from "../../../assets/lottie-animations/dummy-animation";
import {AccessibilityService} from "../../services/accessibility.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {LottieHelperService} from "../../services/lottie-helper.service";

@UntilDestroy({checkProperties: true})
@Component({
  selector: 'brt-lottie',
  templateUrl: './lottie.component.html',
  styleUrls: ['./lottie.component.scss']
})
export class LottieComponent implements AfterViewInit, OnDestroy {

  @Input("lottieOptions") lottieOptions!: AnimationOptions;
  @Output('instanceCreated') instanceCreated = new EventEmitter<AnimationItem>();
  @Input('frameRate') frameRate = -1;

  animationItem?: AnimationItem;

  isStopMovingContent = false;
  constructor(private accessibilityService: AccessibilityService, private lottieHelperService: LottieHelperService) {
  }
  ngAfterViewInit() {

  }

  onAnimationCreated($event: AnimationItem) {
    $event.addEventListener("DOMLoaded",  () => {
      this.instanceCreated.emit($event);
      this.animationItem = $event;

      this.accessibilityService.getStopMovingContent().pipe(untilDestroyed(this)).subscribe((newValue) => {
        this.isStopMovingContent = newValue;
        if(this.animationItem) {
          if(this.isStopMovingContent) {
            this.animationItem.pause();
          } else {
            if(this.animationItem.autoplay) {
              this.animationItem.play();
            }
          }
        }
      })
    });

    $event.addEventListener("data_ready", () => {
      if(this.frameRate !== -1) {
        // $event.frameRate = 1;
        // $event.frameMult = 0.001;
        // $event.setSpeed(1);
      }
      // $event.frameRate = 1;
      // $event.frameMult = 0.001
    })
    // $event.frameRate = 25;
  }

  onSegmentStart($event: BMSegmentStartEvent) {
    // console.log($event);
  }

  ngOnDestroy() {
    if(this.animationItem) {
      this.lottieHelperService.removeAnimation(this.animationItem);
    }
  }
}
